export enum RETURN_ITEM_TYPE {
  DEVOLUCION_UTILIZADO = 0,
  DEVOLUCION_NO_UTILIZADO = 1,
  SOLICITUD_REPARACION = 2,
}

export const ReturnItemTypeString = {
  [RETURN_ITEM_TYPE.DEVOLUCION_UTILIZADO]:
    'Devolución de un elemento que ya fue utilizado en campo',
  [RETURN_ITEM_TYPE.DEVOLUCION_NO_UTILIZADO]:
    'Devolución de un elemento entregado pero no utilizado',
  [RETURN_ITEM_TYPE.SOLICITUD_REPARACION]:
    'Solicitud de reparación o revisión técnica del elemento',
};
